module.exports = __webpack_public_path__ + "files/37a8f82d8b98f95f1f0cc774054b2251.png";